import style from './loadingOverlay.module.css';
import Spinner from '../Spinner';

export interface LoadingOverlayProps {
  text?: string;
}

function LoadingOverlay(props: LoadingOverlayProps) {
  const { text } = props;

  const spinner = (
    <div className={style.container}>
      <Spinner />
    </div>
  );

  const spinnerWithText = (
    <div className={style.spinnerWithTextContainer}>
      <Spinner />
      <p className={style.text}>{text}</p>
    </div>
  );

  return (
    <div className={style.overlay}>
      {text ? spinnerWithText : spinner}
    </div>
  );
}

export default LoadingOverlay;
